import script from "./PublicProjectsExplorer.vue?vue&type=script&setup=true&lang=js"
export * from "./PublicProjectsExplorer.vue?vue&type=script&setup=true&lang=js"

import "./PublicProjectsExplorer.vue?vue&type=style&index=0&id=b1dc0292&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b1dc0292"]])

export default __exports__